import { render, staticRenderFns } from "./ProductSingleVariants.vue?vue&type=template&id=927981ec&"
import script from "./ProductSingleVariants.vue?vue&type=script&lang=js&"
export * from "./ProductSingleVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports